import CategoriesPopover from './CategoriesPopover';
import withDataCategories from './withDataCategories';

export default withDataCategories(CategoriesPopover);
